module.controller('sampleScheduleCalendarCtrl', [ '$compile', '$scope', '$rootScope', '$state', 'alertService', 'uiCalendarConfig', 'planSamplingService',
		sampleScheduleCalendarCtrlFn ]);

function sampleScheduleCalendarCtrlFn($compile, $scope, $rootScope, $state, alertService, uiCalendarConfig, planSamplingService) {
	var vm = this;
	
	var utilCale = new utilFeeCalendar();
	vm.calconf = uiCalendarConfig;
	$scope.popup1 = {
		opened : false
	};
	vm.dt;

	vm.pru = function() {
		$scope.popup1.opened = true;
	}

	/*
	 * se ejecuta eal cargar el controlador
	 */
	function init() {

	}

	/**
	 * Cuando se hace drop de un objeto externo
	 */
	function onDrop(date, jsEvent, ui, resourceId) {
		var rex = /(sample)(\d+)/gi;
		var id = rex.exec(this.id)[2];
		// lee el evento del calendario
		var event = uiCalendarConfig.calendars["sampleCalendar"].fullCalendar('clientEvents', id);
		// pregunta si existe el evento
		if (event && event.length > 0) {
			event = event[0];
			var text = "<small class='text-danger'>la muestra está programada para " + event.start.calendar() + "</small><br/>¿Desea reprogramarla para "
					+ date.calendar() + "?";
			alertService.showSwtQuestionRaw("Reprogramar muestra", text, function() {
				var sample = $scope.ctrl.findSampleByid(id);
				$scope.ctrl.scheduleSample(sample.planSampling.id, sample.sampling.id, sample.id, moment(date), function() {
					// actualiza la fecha
					event.start = date;
					uiCalendarConfig.calendars["sampleCalendar"].fullCalendar('updateEvent', event);
					vm.renderEvent(event);
					$scope.ctrl.updateSample(sample.planSampling.id, sample.sampling.id, sample.id);
				});

			});
		} else {
			// crea el evento
			var sample = $scope.ctrl.findSampleByid(id);
			var event = $scope.ctrl.sample2Event(sample);
			event.start = date;

			$scope.ctrl.scheduleSample(sample.planSampling.id, sample.sampling.id, sample.id, moment(event.start), function() {
				vm.renderEvent(event);
				$scope.ctrl.updateSample(sample.planSampling.id, sample.sampling.id, sample.id);
			});

		}
		console.log(date);
	}

	/**
	 * Cuando se hace un drop dentro del mismo calendario
	 */
	function alertOnDrop(event, delta, revertFunc, jsEvent, ui, view) {
		var sample = $scope.ctrl.findSampleByid(event.id);
		var tmpDate = sample.scheduleDate;
		sample.scheduleDate = moment(event.start);

		$scope.ctrl.scheduleSample(sample.planSampling.id, sample.sampling.id, sample.id, moment(event.start), undefined, function() {
			sample.scheduleDate = tmpDate;
			revertFunc();
		});
	}

	/*
	 * Si se hace click en un evento
	 */
	function onEventClick(calEvent, jsEvent, view) {
		console.log(view);
		$scope.ctrl.setSampleSelected($scope.ctrl.findSampleByid(calEvent.id));
	}

	/**
	 * si se hace click en un dia
	 */
	function onClickDay(date, jsEvent, view) {
		uiCalendarConfig.calendars["sampleCalendar"].fullCalendar('gotoDate', date);
		uiCalendarConfig.calendars["sampleCalendar"].fullCalendar('changeView', 'agendaDay');
	}
	/**
	 * View render si pone el icino en el botton personalizado y se le aocia un
	 * tooltip
	 */
	function onViewRender(view, element) {
		var customButton = $(".fc-myCustomButton-button");
		customButton.daterangepicker({
			"singleDatePicker" : true,
			"autoApply" : true
		}, function(start, end, label) {
			uiCalendarConfig.calendars["sampleCalendar"].fullCalendar('gotoDate', moment(start));
		});

		var icono = $(".fc-myCustomButton-button .fa.fa-calendar");
		if (icono.length === 0)
			$(".fc-myCustomButton-button").append("<i class='fa fa-calendar'></i>");

		customButton.qtip({
			content : "Ir a...",
			style : 'qtip-dark  qtip-shadow'
		});

	}
	
	vm.renderEvent = function(event){
		uiCalendarConfig.calendars["sampleCalendar"].fullCalendar('renderEvent', event, true);
	}
	
	/**
	 * eventAfterRender
	 */
	$scope.onEventAfterRender = function(event, element, view) {
		var sample = $scope.ctrl.findSampleByid(event.id);
		$scope.ctrl.setToolTip(element, sample)

		// se pone el ícono de usuario si está asignado
		if (event.isAsigned)
			element.find('.fc-time').prepend("<i class='fa fa-user fa-fw'></i> ");
		// se pone el chulo si quieriere confirmación
		if (event.requireConfirmation)
			element.find('.fc-title').prepend("<i class='fa fa-check-square-o fa-fw'></i> ");
		// Informacion de vista de semana
		if (view.name === 'agendaWeek') {
			var t = element.find('.fc-title');
			if (event.tag) {
				t.after("<div class='fc-title'><b>" + event.tag + "</b></div>");
			}
			t.after("<div class='fc-title'><b>" + event.product + "</b></div>");
		}
		// información de vista de día
		if (view.name === 'agendaDay') {
			var t = element.find('.fc-title');
			if (event.tag) {
				t.after("<div class='fc-title'><i class='fa fa-tag' ></i> <b>" + event.tag + "</b></div>");
			}
			t.after("<div class='fc-title'><product-icon></product-icon> " + event.product + "</div>");
			$compile(element)($scope);
		}
	}

	/* configuracion del calendario */
	vm.uiConfig = {
		calendar : {
			timezone : 'local',
			locale : 'es',
			height : 'auto',
			editable : true,
			allDaySlot : false,
			navLinks : true, // valido para la veroion 3.0
			droppable : true,
			customButtons : {
				myCustomButton : {
					text : '',
					click : function() {
						$scope.popup1.opened = true;
					}
				}
			},
			header : {
				left : 'prev,next today myCustomButton',
				center : 'title',
				right : 'month,agendaWeek,agendaDay,list'
			},
			eventLimit : true,
			defaultView : 'agendaWeek',
			eventOverlap : true,
			firstDay : utilCale.getFirstDay(),
			views : {
				month : {
					timeFormat : 'h(:mm)t'
				}
			},

			drop : onDrop,
			eventClick : onEventClick,
			eventDrop : alertOnDrop,
			dayClick : onClickDay,
			eventAfterRender : $scope.onEventAfterRender,
			viewRender : onViewRender,

		}
	};

}